import React, { createContext, useMemo, useState } from 'react';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

// No `key` on the provider: a color change must re-theme the tree, not remount it. With
// key={mainColor} every setMainColor remounted the whole app, so two components that set
// different colors on mount (the Feel widget and the panel branding) remounted each other
// forever: a white provider page and thousands of API calls for logged-in users.
const DynamicThemeProvider = ({
  children,
  theme
}) => {
  const [mainColor, setMainColor] = useState(null);
  const muiTheme = useMemo(() => createTheme(theme(mainColor)), [theme, mainColor]);
  const value = useMemo(() => ({
    mainColor,
    setMainColor
  }), [mainColor]);
  return /*#__PURE__*/React.createElement(DynamicThemeContext.Provider, {
    value: value
  }, /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: muiTheme
  }, children));
};
const DynamicThemeContext = /*#__PURE__*/createContext();
DynamicThemeProvider.propTypes = {
  theme: PropTypes.func.isRequired
};
export { DynamicThemeContext, DynamicThemeProvider };